export const SUPPORT_TEAMS = 'supportTeams';
export const SUPPORT_TOPICS = 'supportTopics';
